import Vue from 'vue'
import Router from 'vue-router'
import {HRM} from '@/View/HRM/router/index.js'
import {systemSetting} from '@/View/systemSetting/routers/index.js'
import {CRM} from '@/View/CRM/router/index.js'
import {CustomerSupport} from '@/View/CustomerSupport/router/index.js'
import {Sales} from '@/View/Sales/router/index.js'

Vue.use(Router)
export const constantRouterMap = [
  {
    path: '/',
    hidden: true,
    redirect: '/dashboard'
  },
  { // email Indentifier
    path: '/emailVerify',
    name: 'emailVerify',
    component: () => import('@/View/Auth/emailIdentify.vue')
  },
  { // Login Page
    path: '/login',
    component: () => import('@/View/Auth/login.vue'),
    hidden: true,
    name: 'login',
    meta: {
      title: 'login',
      selected: false,
      permissionList: []
    }
  },
  {
    // Dashboard
    path: '/dashboard',
    component: () => import('@/View/dashboard/dashboard.vue'),
    hidden: true,
    name: 'dashboard',
    meta: {
      title: 'dashboard',
      selected: false,
      permissionList: []
    }
  },
  HRM,
  systemSetting,
  CRM,
  CustomerSupport,
  Sales
]
export default new Router({
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js